import React from 'react';
import PurchaseOrderStepper from './PurchaseOrderStepper';
import PurchaseOrderHeader from './PurchaseOrderHeader';

import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';

import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet, useSnackbar } from '@components/Provider';
import {
  CapaErrorCode,
  useRegisterRequestRfqQuotationMutation
} from '@generated/graphql';
import { useHistory } from 'react-router-dom';
import { RfqIcon } from '@assets';
import {
  CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT,
  CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT_MOBILE,
  CHAT_DRAWER_TITLE_BAR_HEIGHT,
  CHAT_MENU_WIDTH,
  DOCUMENTS_STEPPER_HEIGHT
} from '@components/Chat/constants';

interface Props {
  rfqId?: string;
  partnerId?: string;
  isClosedConsulting: boolean;
}

const PurchaseOrderNotFound = ({
  rfqId,
  partnerId,
  isClosedConsulting
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const location = history.location;

  const isDashboard = location.pathname.includes('/dashboard');

  const [registerRequestQuotation] = useRegisterRequestRfqQuotationMutation();

  const requestToRegisterQuotation = async () => {
    if (!rfqId || !partnerId) return;

    const { data } = await registerRequestQuotation({
      variables: {
        input: {
          rfqId,
          partnerId
        }
      }
    });

    if (
      data?.registerRequestRfqQuotation.result ===
      CapaErrorCode.ChatroomNotFound
    ) {
      history.push(history.location.pathname);

      return enqueueSnackbar('상담이 종료된 채팅방입니다.', {
        variant: 'error'
      });
    }

    history.push(history.location.pathname);
  };

  return (
    <>
      {!isDashboard && <PurchaseOrderHeader hasPurchaseOrderHistory={false} />}

      {!isDashboard ? <PurchaseOrderStepper /> : null}

      <div className={classes.root}>
        <img className={classes.notfound} src={RfqIcon} alt="" />
        <CustomizedTypography
          color="textPrimary"
          variant="body1"
          align="center"
          gutterBottoms={8}
        >
          제조를 시작하려면 견적서가 필요합니다
        </CustomizedTypography>
        <CustomizedTypography
          color="textSecondary"
          variant="body2"
          align="center"
        >
          파트너와의 상담을 바탕으로 견적서를 요청하세요.
          <br />
          해당 견적서를 기반으로 제조 프로젝트를 진행할 수 있습니다.
        </CustomizedTypography>
      </div>

      {!isDashboard && (
        <div className={classes.fixed}>
          <CustomizedButton
            disabled={isClosedConsulting}
            size="large"
            color="primary"
            variant="contained"
            onClick={requestToRegisterQuotation}
            fullWidth={matches}
          >
            견적서 요청
          </CustomizedButton>
        </div>
      )}
    </>
  );
};

export default PurchaseOrderNotFound;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    height: `calc(100vh - ${CHAT_DRAWER_TITLE_BAR_HEIGHT}px - ${DOCUMENTS_STEPPER_HEIGHT}px - ${CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT}px)`,
    position: 'relative',
    zIndex: -1,
    [theme.breakpoints.down('md')]: {
      height: `calc(100vh - ${CHAT_DRAWER_TITLE_BAR_HEIGHT}px - ${DOCUMENTS_STEPPER_HEIGHT}px - ${CHAT_DRAWER_FIXED_BOTTTOM_CTA_HEIGHT_MOBILE}px)`,
      padding: '0px 36px'
    }
  },
  notfound: {
    width: 80,
    height: 80,
    marginBottom: 32
  },
  fixed: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'fixed',
    bottom: 0,
    width: `calc(100% - ${CHAT_MENU_WIDTH}px)`,
    padding: '20px 24px',
    borderTop: `1px solid ${colorSet.gray400}`,
    borderRight: `1px solid ${colorSet.gray400}`,
    backgroundColor: colorSet.gray000,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: 16
    }
  }
}));
